import { useClientPortalConfigContext } from "../../context/ClientPortalConfig.ctx";
import { useGetQuery, useDefaultHandleAxiosErrorProps } from "../../hooks/useClientPortalQuery";
import { InvoiceItemModel, InvoicePayErrorApiDetailsErrorResponse } from "../../types/generated/models";
import { AxiosError } from "axios";
import { useClientPortalNavigate } from "../../hooks/useClientPortalRouter";
import { ROUTES } from "../../routes";
import { enqueueSnackbar } from "@powerdiary/components-library/lib/components/Snackbar";
import { ErrorProps, handleAxiosError } from "../../hooks/useClientPortalQuery.helpers";

interface IInvoiceDetailsHook {
    invoice?: InvoiceItemModel | null;
    invoiceLoading: boolean;
    fetchInvoice?: () => Promise<{ data?: InvoiceItemModel }>;
}

export function useInvoiceDetails(publicId: string, invoiceId: string): IInvoiceDetailsHook {
    const { clientPortalGuid, clientPortalConfig } = useClientPortalConfigContext();
    const navigateTo = useClientPortalNavigate();
    const defaultHandleAxiosErrorProps = useDefaultHandleAxiosErrorProps();

    const { data, isLoading, refetch } = useGetQuery<InvoiceItemModel | null>({
        url: `/api/v1/${clientPortalGuid}/Invoices/Invoice/${publicId}/${invoiceId}`,
        handleCustomError: (error: AxiosError) => {
            const response = error.response?.data as InvoicePayErrorApiDetailsErrorResponse;
            if (response.details) {
                enqueueSnackbar(
                    `${response.message}${!clientPortalConfig.userLoggedIn && response.details.title !== "Expired Link" ? " Please log in if you wish to download a copy." : ""}`,
                    { variant: "info", alertTitle: response.details.title }
                );
                if (response.details.redirectToNotAvailable) {
                    navigateTo(ROUTES.NOT_AVAILABLE.urlPath);
                    return;
                }
                if (response.details.redirectToInvoicesPage) {
                    navigateTo(clientPortalConfig.userLoggedIn ? ROUTES.INVOICES.urlPath : ROUTES.HOME.urlPath);
                }
            } else {
                handleAxiosError({ ...defaultHandleAxiosErrorProps, error } as ErrorProps);
            }
        },
    });

    return { invoice: data, invoiceLoading: isLoading, fetchInvoice: refetch };
}
